import * as React from 'react';
import { ContentEventCalendar } from './ContentEventCalendar';

export class CalendarPage extends React.Component {
    render() {
        return <div className="calendar-container">
            <ContentEventCalendar isSmall={false}></ContentEventCalendar>
        </div>;
    }
}